import { render, staticRenderFns } from "./AvisosMes.vue?vue&type=template&id=05c88cd3&"
import script from "./AvisosMes.vue?vue&type=script&lang=js&"
export * from "./AvisosMes.vue?vue&type=script&lang=js&"
import style0 from "./AvisosMes.vue?vue&type=style&index=0&id=05c88cd3&prod&lang=css&"
import style1 from "./AvisosMes.vue?vue&type=style&index=1&id=05c88cd3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports